export default {
    accepted: true
}